var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-4" },
    _vm._l(_vm.routes, function(route, index) {
      return _c(
        "div",
        { key: route.sequence_index },
        [
          _c("booking-flight-route-detail", { attrs: { route: route } }),
          _vm.transfers.length > index
            ? _c(
                "div",
                [
                  _c("v-divider"),
                  _c(
                    "v-row",
                    { staticClass: "justify-space-around flight-divider" },
                    [
                      _c("v-col", { attrs: { cols: "8" } }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "white px-2 ml-5 accent--text flight-divider-text"
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("booking.transfer")) + " "
                            ),
                            _c(
                              "v-icon",
                              {
                                staticClass: "accent--text",
                                attrs: { small: "" }
                              },
                              [_vm._v("shuffle")]
                            )
                          ],
                          1
                        )
                      ]),
                      _c("v-col", { attrs: { cols: "2" } }, [
                        _c("span", { staticClass: "white pl-2" }, [
                          _vm._v(
                            " " + _vm._s(_vm.transfers[index].city_name) + " "
                          )
                        ]),
                        _c("span", { staticClass: "white pr-2 accent--text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.transfers[index].airport_code) +
                              " "
                          )
                        ]),
                        _vm.transfers[index].airport_name != null
                          ? _c(
                              "span",
                              { staticClass: "white px-2 grey--text" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.transfers[index].airport_name) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-col",
                        {
                          staticClass: "text-right primary--text",
                          attrs: { cols: "2" }
                        },
                        [
                          _c("span", { staticClass: "white px-2" }, [
                            _vm._v(
                              " " + _vm._s(_vm.transfers[index].time) + " "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }